<template>
    <div class="container mt-5">

    <router-link class="btn-back" to="/"><i class="fas fa-long-arrow-alt-left"></i> Retourner à l'accueil</router-link> <span class="ml-5 grey">{{ $t('translation') }}</span>
    <div class="titleProduct"><img src="@/assets/img/BourseEchange.png" class="img-fluid logoProd" alt="Bourse d'Echange"> Echange agris</div>
    <div class="label ml-3">Echanges entre agriculteurs</div>
    
    <!-- <div class="row">
        <div class="col">
            <div class="text-center">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/WxPycRea15I" modestbranding="1" rel="0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
        <div class="col">
            <div class="highlighted">
                Intégrable à l’extranet de la coopérative, cette application web est une plateforme d’annonces pour permettre aux agriculteurs/viticulteurs d’échanger leurs apports livrés par la coopérative, tout en assurant le suivi et la traçabilité des numéros de lots.
            </div>
        </div>
    </div> -->
    
    <!-- <div class="highlighted mt-4">Avantages </div>
    <ul>
        <li>Site web qui s’intègre dans l’extranet d’une coopérative </li>
        <li>Plateforme de petites annonces pour échanger sur les apports livrés par la coop</li>
        <li>Recherche et publication d’annonce en fonction du profil des commandes faites à la coop</li>
    </ul>

        
    <div id="demoBE" class="mt-4 mb-4">
       Le site intègre toutes les fonctionnalités d’une place de marché avec notamment un moteur de recherche performant, une classification des articles par catégorie, une messagerie instantanée permettant à l’acheteur d’être en contact avec le magasin, le paiement sécurisé, le click and collect et le processus d’information (Notifications, mails..) de mise à disposition des produits coté acheteur, une publication facilitée (via mobile) et un processus de facturation harmonisée avec la comptabilité interne coté vendeur.
       A son lancement, Dans ton jardin bénéficie de plus de 10 points de retrait sur la Champagne-Ardenne, les Hauts de France et la Seine et Marne, pour permettre aux clients d’aller chercher leurs commandes en toute facilité suivant le principe du Click & Collect. Bientôt, un service de livraison et de nouveaux fournisseurs pour répondre encore plus précisément à leurs besoins, leurs envies, et surtout pour leur faciliter la vie dans leur jardin. 
    </div> -->

    <div class="row">
        <div class="col d-flex align-items-center">
            <!-- <img src="@/assets/img/presse/echangesem23.png" class="img-fluid mb-2" alt=""> -->
            <video src="@/assets/video/SEM.webm" autoplay loop controls></video>
            <!-- <img src="@/assets/img/illustrations/echange_semences/agri.jpg" class="img-fluid" alt=""> -->
        </div>
        <div class="col-lg-6 col-md-8">
            <div class="highlighted mt-4">Faciliter les échanges entre agriculteurs : les avantages pour une coopérative </div>
            <p>Les coopératives agricoles sont au cœur de la vie économique et sociale des territoires ruraux. Elles ont pour mission de regrouper les agriculteurs et de défendre leurs intérêts, tout en leur apportant des services et des outils pour améliorer leur performance et leur rentabilité. Parmi ces services, la facilitation des échanges entre agriculteurs occupe une place centrale, avec de nombreux avantages pour les coopératives :</p>
        </div>
    </div>
    <p><strong>Traçabilité des échanges</strong> : En permettant aux agriculteurs de s'échanger entre eux les approvisionnements qu'ils n'ont pas utilisés, la coopérative peut suivre en temps réel les transactions et avoir une vision claire de l'ensemble des échanges réalisés sur son territoire. Cette traçabilité assure la transparence des échanges, permet de mieux gérer les stocks et contribue à la sécurité de la production.</p>
            <p><strong>La refacturation des échanges</strong> peut être gérée par la coopérative, ce qui offre un service supplémentaire aux agriculteurs. Cette refacturation facilite les transactions et permet aux agriculteurs de se concentrer sur leur activité principale, sans avoir à gérer la comptabilité de leurs échanges.</p>
            <p><strong>Optimisation de l'utilisation des approvisionnements</strong> sur son territoire. En effet, les échanges permettent de mieux répartir les approvisionnements en fonction des besoins des agriculteurs et des spécificités des exploitations. Cela permet de réduire les pertes liées aux invendus et d'optimiser les flux logistiques.</p>

    <div class="highlighted mt-5">Ils utilisent déjà Echanges Agris</div>

    <div class="row clients-logo text-center">
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/vivescia.png" alt="Logo Vivescia"></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/ceresia.png" alt="Logo Ceresia"></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/logo_novagrain.svg" alt="Logo Novagrain"></div>
    </div>


    <div class="my-5 row">
        <div class="col-lg-6 col-md-8 largeText text-left mt-5">
            <ul>
                <li>Intégré à leur extranet, cette plateforme d'annonces permet à leurs adhérents d'échanger leurs appros et leur assure le contrôle et la traçabilité des échanges.</li>
                <li>Version application mobile pour téléphone Apple et Android</li>
                <li>Design personnalisé selon la charte de la coopérative et UX optimale pour ses utilisateurs</li>
            </ul>
        </div>
        <div class="col  d-flex align-items-center"><img src="@/assets/img/illustrations/echange_semences/mockupES.png" class="img-fluid" alt=""></div>
    </div>
    
    
   
    <div class="row">
        <div class="col-lg-7 col-md-8 text-justify">
            <div class="highlighted mt-4">Au-delà des avantages pratiques : un service de mutualité et de coopération </div>
    
                <p>Au-delà des avantages pratiques que peuvent apporter la facilitation des échanges entre agriculteurs, il est important de souligner que ce service renforce le sens premier de la coopération agricole, à savoir <strong>la solidarité et la coopération</strong>. En effet, les coopératives agricoles ont été créées dans un contexte de mutualisation des moyens et de partage des risques, pour permettre aux agriculteurs de faire face aux défis économiques et sociaux qui se posaient à eux. La facilitation des échanges entre agriculteurs s'inscrit donc dans cette logique de coopération et de solidarité, en permettant aux agriculteurs de s'entraider et de mieux gérer leurs approvisionnements.</p>
                <p>Il est donc essentiel de valoriser cette dimension de la coopération agricole, en mettant en avant les bénéfices que peuvent en retirer les agriculteurs mais aussi en soulignant son importance pour suivre l'évolution des pratiques agricoles. En effet, les pratiques agricoles évoluent rapidement, sous l'impulsion de l'innovation et des nouvelles technologies. Pour rester compétitives et répondre aux besoins des agriculteurs, les coopératives doivent elles aussi évoluer et proposer des services innovants et adaptés à leurs membres. La facilitation des échanges entre agriculteurs est l'un de ces services, qui permet aux coopératives de se différencier et de valoriser leur rôle de partenaire privilégié des agriculteurs.</p>
                <p>En somme, la facilitation des échanges entre agriculteurs est bien plus qu'un simple service pratique : elle est un vecteur de coopération et de solidarité, qui renforce le sens premier de la coopération agricole. Pour les coopératives, il est donc essentiel de valoriser cette dimension de leur activité, pour rester compétitives et accompagner au mieux leurs membres dans leur évolution.</p>

        </div>
        <div class="col d-flex align-items-center">
            <img src="@/assets/img/presse/echangesem23.png" class="img-fluid mb-2" alt="">
        </div>
    </div>
    

    <div class="row mt-5 mb-5 text-center">
        <router-link class="btn btn-primary mx-auto" to="/actualites/bourse-vivescia">Témoignage Vivescia </router-link>
    </div>

    <!-- <div class="row">
        <div class="col">
            Application simplifiant l'échange de semences entre adhérents
        </div>
        <div class="col"></div>
    </div>
    <div class="row">
        <div class="col">
            Traçabilité simplifiée des semences échangées pour les coopératives
        </div>
        <div class="col"></div>
    </div>
    <div class="row">
        <div class="col">
            Réduction des coûts liés à la gestion des échanges entre adhérents 
        </div>
        <div class="col"></div>
    </div> -->


    <!-- <div class="container mb-5 mt-5">
        <div class="row">
            
            <div class="col imgContainer">
                <router-link class="imgLink" to="/solutions/echangesemences/agriculteur">
                    <img src="@/assets/img/illustrations/echange_semences/agri.jpg" class="img-fluid" alt="">
                    <div class="imgTitle">Agriculteur <br> Cliquez ici</div>
                </router-link>
            </div>
            <div class="col imgContainer">
                <router-link class="imgLink" to="/solutions/echangesemences/corporate">
                    <img src="@/assets/img/illustrations/echange_semences/hand.jpg" class="img-fluid" alt="">
                    <div class="imgTitle">Coopérative / Négoce <br> Cliquez ici</div>
                </router-link>
            </div>
        </div>
    </div> -->

<!-- <div  class="container mt-5 mb-5">
    <div class="contact-block text-center ml-5 mr-5">
      <div class="block_title text-center">Accès à la démo Echange semences</div>
      <div class="imgContact">
          <div class="form-group">
              <label class="formLabel"  for="login">Email/login</label>
              <input  v-model="login" required  type="email" class="form-control" id="txtlogin" aria-describedby="login">
          </div>
          <div class="form-group">
              <label class="formLabel" for="mdp">Mot de passe</label>
              <input  v-model="mdp"  type="password" class="form-control" id="txtmdp" aria-describedby="mdp">
          </div>
          <button v-on:click="toDap()" class="form-group btn btn-secondary ">Se connecter</button>
          
          <div class="result" v-bind:class="{ 'text-danger': hasError }">{{ result }}</div>
      </div>
      <router-link class="btn btn-primary mx-auto" to="/contact-demo">Demander un accès </router-link>
    </div>    
</div> -->


    <MailjetNewsLetter/>

  </div>
</template>

<script>
    import MailjetNewsLetter from '@/components/MailjetNewsLetter'
    export default {
        name: 'EchangeSemences',
        data(){
        return {
            login: '',
            mdp:'',
            hasError:false,
            result:''
        }
        },         
        components:{
            MailjetNewsLetter
        },
        methods:{
            toDap () {
                this.hasError = false
                this.result = ''
                if (!this.login || this.login.trim() === '' || this.mdp.trim() === '' || !this.mdp) {
                this.hasError = true
                this.result = 'Merci de renseigner tous les champs demandés pour envoyer votre demande'
                } else {
                const jeton = window.btoa(unescape(encodeURIComponent("loginTiers="+this.login+"&password=" + this.mdp)));
                const uri = "http://localhost:3000?jetonsso="+jeton;
                const encoded = encodeURI(uri);
                window.open(encoded, '_blank');
                }
            }
        },
        props:{}
    }
</script>

<style lang="scss" scoped>


    iframe{
        border-radius: 20px;
    }
    video{
        border-radius: 10px;
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        width: 100%;
        margin-top: 50px;
        margin-bottom: 50px;
        &:hover{
            cursor:auto;
        }
    }v
    .label{
            background-color: var(--mainGreen);
            color: var(--mainBleu);
            font-weight: 600;
            font-size: 25px;
            padding-left: 5px;
            border-radius: 0px;
            margin-bottom: 100px;
        }

    .titleProduct{
        text-align: left;
        font-weight: 600;
        font-size: 55px;
        color: var(--mainBlue);
        padding-top: 50px;
    }
    .largeText{
        text-align: left;
        font-weight: 600;
        font-size: 20px;
        li{
            padding-bottom: 20px;
        }
    }

    .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }

    .zoomIn {
        transition: transform .2s;
        position: relative;;
        &:hover{
           transform: scale(1.9);
           position: absolute;
           z-index: 10;
        }
    }

    .imgContainer{
        overflow: hidden;
        border-radius: 2px;
        .imgLink{
            display: flex;
            justify-content: center;
            align-items: center;
            .imgTitle{
                align-content: center;
                position: absolute;
                text-align: center;
                color: white;
                font-weight: 600;
                font-size: 25px;
                &:hover{
                    cursor: pointer;
                    color: var(--mainGreen);
                }
            }
        }
        
        img{
            transition: transform .2s;
            border-radius: 2px;
            -webkit-box-shadow: var(--box-shadow, 1px 1px 4px 0 rgba(0, 0, 0, 0.15));
            box-shadow: var(--box-shadow, 1px 1px 4px 0 rgba(0, 0, 0, 0.15));
            
        }
    }


 .featuresList{
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        img{
            padding: 5px;
            margin-bottom: 40px;
        }
    }

    .poductLink{
        background-color: white;
        border: var(--mainBlue) 10px solid;
        border-radius: 20px;
        padding: 30px;
        text-align: center;
    }

     .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }

    .contact-block {
        color: white;
        font-weight: 600;
        font-size: 25px;
        background-color: var(--mainBlue);
        padding: 20px;
        border-radius: 18px;
        text-align: center;
    .tagline{
      padding: 50px 0px 20px 0px;
    }
    .styledInput{
        margin: auto;
        border-radius: 25px;
        max-width: 300px;
        height: 45px;
    }
    .button-input{
        background-color: var(--mainGreen);
        color: white;
        position: relative;
        height: 40px;
        top: -42.5px;
        left: 105px;
        z-index: 20;
        &:hover{
            background-color: var(--mainBlue);
        }
    }
    .form-group{
    
      .formLabel{
          font-size: 16px;
          font-weight: 600;
      }
      .form-text{
          font-size: 13px;
          font-weight: 400;
      }
    }
    
    .block_title {
      color: var(--mainGreen);
      text-align: left;
    }
    
    .result {
        font-weight: 600;
        margin-top: 10px;
        color: var(--mainGreen);
    }
    }
     .logoProd {
        max-height: 120px;
    }
</style>